import classNames from "classnames";
import Image from "next/image";
import { FC } from "react";
import { Container } from "~/components/Container";
import InfiniteScroll from "~/components/InfiniteScroll";
import { brands } from "~/constants/data";
import styles from "./Brand.module.scss";

interface BrandProps {
  className?: string;
}

const Brand: FC<BrandProps> = ({ className }) => {
  return (
    <section className={classNames(styles.brand, className)} id="brand">
      <Container className={styles.container}>
        <p className={styles.title}>
          Loved by <span className={styles.strong}>100,000+</span>
          <br />
          users across industries
        </p>

        <div className="overflow-hidden flex-1 w-full">
          <InfiniteScroll
            height={49}
            items={brands.map((brand, index) => (
              <Image
                src={brand.icon}
                key={index}
                alt={brand.name}
                width={brand.width}
                height={36}
                className="mx-4 grayscale user-select-none"
              />
            ))}
          />
        </div>
      </Container>
    </section>
  );
};

export default Brand;
